import { render } from "./Olap.vue?vue&type=template&id=b9f1c95e&ts=true"
import script from "./Olap.vue?vue&type=script&lang=ts"
export * from "./Olap.vue?vue&type=script&lang=ts"

import "./Olap.vue?vue&type=style&index=0&id=b9f1c95e&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__